import filter from 'lodash/filter';
import head from 'lodash/head';

export class ReportListService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
        this.apiService = ApiService;
    }

    getReportListObject(details, moduleName) {
        return {
			overview: this._getOverviewDetails(details.data.menuOverviewDetails),
			list: this._getSubContentDetails(details.data.content, moduleName)
		};
    }

    /*************************************************Private Methods************************ */

    _getSubContentDetails(values, moduleName) {
		let details = filter(values, ['name', moduleName]);
        return _getListDetails.call(this, head(details).values);

        function _getListDetails(data) {
            return data.map(value => this._getListObject(value));
        }
	}

    _getOverviewDetails(details) {
		return {
			title: details.title,
			description: details.description,
			image: details.image,
			overview: details.overview
		}
	}

    _getContentDetails(content) {
		return content.map(({ title, description, name }) => ({ title, description, name }));
	}

    _getListObject(value) {
		return {
			id: value.content_id,
			image: this.apiService.getResourceUrl(`files/images/${value.image}`),
			pdf: this.apiService.getResourceUrl(`files/pdf/${value.pdf}`),
			title: value.title,
			slug: value.slug || ''
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/report-list/report-list.service.js